import {Injectable} from '@angular/core';
import { of } from 'rxjs';

export enum LOCAL_STORAGE_KEY {
    USER = 'USER',
    'BREADRUMB' = 'BREADRUMB'
}
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  storage: Storage;

  constructor() {
    this.storage = window.localStorage;
  }

  set(key: string, value: string): void {
    this.storage[key] = value;
  }

  get(key: string): string {
    return this.storage[key] || null;
  }

  setObject(key: string, value: any): void {
    if (!value) {
      return;
    }

    this.storage[key] = JSON.stringify(value);
  }

  getObject<T>(key: LOCAL_STORAGE_KEY): T {
    if (this.storage[key]) {
      return JSON.parse(this.storage[key]);
    } else {
      return null;
    }
  }

  getValue<T>(key: string): T | null {
    const obj = JSON.parse(this.storage[key] || null);
    return (obj as T) || null;
  }

  remove(key: string): any {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }

  get length(): number {
    return this.storage.length;
  }

  get isStorageEmpty(): boolean {
    return this.length === 0;
  }
}
